<template>
  <div class="hi-form-area-text-component" :class="{ bulk: type === 'bulk' }">
    <textarea
      id="text"
      @focus="$emit('taFocus')"
      @blur="$emit('taBlur')"
      @keyup.enter="$emit('taBlur')"
      @keyup.space="$emit('taBlur')"
      :placeholder="placeholder"
      :rows="rows"
      ref="tc"
      v-model="value"
    ></textarea>
    <div class="bottom-container">
      <el-popover v-model="showEmoji" :visible-arrow="false" trigger="click">
        <div class="emoji-container">
          <emoji @select="emojiClick"></emoji>
        </div>
        <div slot="reference">
          <div class="emoji-icon">
            <svg
              class="emoji-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="15"
              height="15"
            >
              <path
                d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
              ></path>
              <path
                d="M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
              ></path>
            </svg>
          </div>
        </div>
      </el-popover>
      <el-popover
        v-model="showSearchTag"
        :visible-arrow="false"
        trigger="click"
      >
        <div>
          <tag-search-component
            ref="tagSearch"
            :socialNetwork="socialNetwork"
            @select="tagSelect"
          ></tag-search-component>
        </div>
        <div slot="reference">
          <div class="search-icon"></div>
        </div>
      </el-popover>
      <template v-if="socialNetwork === 'twitter'">
        <div class="message" :class="{ error: textLength > max }">
          {{ `${max - textLength} left` }}
        </div>
      </template>
      <template v-else>
        <div
          class="message"
          :class="{ error: filterNum > max }"
          v-if="filterText"
        >
          {{ `${filterText} ${max - filterNum} left` }}
        </div>
        <div v-else class="message" :class="{ error: currentFilterNum > max }">
          {{ `# ${max - currentFilterNum} left` }}
        </div>
      </template>
    </div>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../../assets/style/theme.less";

.hi-form-area-text-component {
  display: flex;
  flex-direction: column;
  position: relative;

  &.bulk {
    .message {
      font-size: 12px;
      color: rgb(210, 210, 210);
    }
  }

  textarea {
    border: 0;
    width: 100%;
    flex: 1;
    padding: 0;
    font-size: 14px;
    resize: none;
    background: transparent;
    margin-bottom: 20px;
  }

  .bottom-container {
    height: 20px;
    text-align: right;
    display: flex;
    font-size: 14px;
    font-weight: normal;
    align-items: flex-end;
    justify-content: space-between;
    bottom: 0;
    width: 100%;
    position: absolute;
    .emoji-container {
      width: 10px;
      height: 10px;
    }

    .search-icon {
      width: 1px;
      height: 1px;
      background: transparent;
    }

    .emoji-icon {
      width: 15px;
      height: 15px;
      background-size: contain;
      cursor: pointer;
      color: @font-color-gray;
      outline-color: @font-color-gray;
      fill: @font-color-gray;
    }

    .message {
      color: @font-color-gray;

      &.error {
        color: red;
      }
    }
  }
}
</style>
<script>
import _ from "lodash";
import TagSearchComponent from "../../media/schedule/TagSearch.vue";
import data from "emoji-mart-vue/data/messenger.json";
import Emoji from "./emoji";
import { getTextLength } from "../../../utils/index";
export default {
  name: "FormTextAreaComponent",
  components: { Emoji, TagSearchComponent },
  model: {
    // 实现v-model
    prop: "val",
    event: "updateVal",
  },
  props: {
    type: {
      type: String,
      default: "normal",
    },
    rows: {
      // 行数
      type: Number,
      default: 5,
    },
    title: {
      // 左侧标题
      type: String,
      default: "",
    },
    filterText: {
      // 过滤的文本
      type: String,
    },
    max: {
      // 文本最大数量
      type: Number,
      default: 30,
    },
    filterNum: {
      // 已经过滤的数量
      type: Number,
      default: 0,
    },
    val: {
      type: String, // 文本值
      default: "",
    },
    placeholder: {
      // 占位文字
      type: String,
      default: "",
    },
    socialNetwork: {
      type: String,
    },
  },
  data() {
    return {
      data,
      value: this.val, // textarea 值
      showEmoji: false, // 是否显示emoji选项框
      cursorIndex: 0, // 当前光标位置
      searchBegin: 0, // 查到匹配项开始的位置
      showSearchTag: false,
    };
  },
  computed: {
    /**
     * 计算文字长度，因为
     */
    textLength() {
      return getTextLength({
        text: this.value,
        socialNetwork: this.socialNetwork,
      });
    },
    /**
     * 计算#出现次数
     * @returns {number}
     */
    currentFilterNum() {
      const find = [...this.value].filter((v) => {
        return v === "#";
      });
      return find.length;
    },
  },
  methods: {
    emojiClick(native) {
      this.addText(native, false);
      this.showEmoji = false;
    },
    async search({ searchText }) {
      // fb 永远不进行# @的推荐
      if (
        this.socialNetwork === "facebookPage" ||
        this.socialNetwork === "facebookGroup"
      ) {
        return;
      }
      // 如果是tw则只识别@
      if (this.socialNetwork === "twitter" && searchText[0] === "#") {
        return;
      }
      this.showSearchTag = true;
      this.$refs.tagSearch.input(searchText);
    },
    /**
     * tag 点击回调
     */
    tagSelect(item) {
      // 获取光标后面是否还有文案，如果有则加一个空格做间隔
      let space = "";
      if (this.value.substr(this.cursorIndex)) {
        space = " ";
      }
      // 选中之后删除原来的数据
      const beforeStr =
        this.value.substr(0, this.searchBegin + 1) + item.title + space;
      this.value =
        this.value.substr(0, this.searchBegin + 1) +
        item.title +
        space +
        this.value.substr(this.cursorIndex);
      this.setSelect(beforeStr.length);
      this.showSearchTag = false;
    },
    /**
     * 在当前光标处插入文字
     * @param str 添加的文案
     */
    addText(str, hasSpace = true) {
      if (this.value === null) {
        this.value = "";
      }
      // 如果前面已经存在，则需要在新加文字前添加空格
      let space = this.value.length > 0 ? " " : "";
      if (!hasSpace) {
        space = "";
      }
      const beforeStr = this.value.substr(0, this.cursorIndex);
      this.value = `${beforeStr}${space}${str}${this.value.substring(
        this.cursorIndex,
        this.value.length
      )}`;
      // 添加之后将光标移动到之前位置
      this.setSelect(beforeStr.length + str.length);
      this.resetCursor();
    },
    /**
     * 设置光标所在位置
     */
    setSelect(index) {
      const tc = this.$refs.tc;
      if (tc.setSelectionRange) {
        tc.focus();
        this.$nextTick(() => {
          tc.setSelectionRange(index, index);
        });
      }
    },
    /**
     * 重新计算光标位置
     */
    resetCursor() {
      this.$nextTick(() => {
        const tc = this.$refs.tc;
        const startIndex = tc.selectionStart;
        // 记录当前光标位置
        this.cursorIndex = startIndex;
      });
    },
  },
  watch: {
    /**
     * 监听文本值变化，变化时触发updateVal事件，实现双向绑定
     */
    value() {
      this.$emit("updateVal", this.value);
    },
    /**
     * 当props val变化时改变data中value值，从而实现双向绑定
     */
    val(val) {
      this.value = val;
    },
    /**
     * 检测当前光标位置是否存在查询 @ # 的情况
     * @param val
     */
    cursorIndex(val) {
      this.showSearchTag = false;
      // 截取光标之前文案
      const str = this.value.substr(0, val);
      let searchText = "";
      const index = _.findLastIndex(str, (s) => {
        return s === "#"; /* || s === "@"; */
      });
      // 如果能找到对应标识符 则判断是否存在空格即可
      if (index !== -1) {
        const text = str.substr(index, str.length);
        if (
          text.length > 1 &&
          [...text].findIndex((t) => t === " " || t === "\n") === -1
        ) {
          // 说明能找到# @ 符号且没有用空格或回车隔开(#123 符合要求， #123 123不符合要求)
          searchText = text;
        }
      }
      if (searchText) {
        // 记录拼配字符串开始的位置
        this.searchBegin = val - searchText.length;
        this.search({ searchText });
      }
    },
  },
  mounted() {
    this.$refs.tc.addEventListener("keyup", () => {
      this.resetCursor();
    });
    this.$refs.tc.addEventListener("click", () => {
      this.resetCursor();
    });
  },
};
</script>
